export const routes = {
  home: { path: "/" },
  products: { path: "/products" },
  productDetails: { path: "/product_details/:id" },
  about: { path: "/about" },
  contact: { path: "/contact" },
  stores: { path: "/stores" },
  cart: { path: "/cart" },
  profile: { path: "/profile" },
  login: { path: "/login" },
} as const satisfies Record<string, { path: string }>;
